import angular from 'angular'
import './scheduled_message.service'
import moment from 'moment-timezone'

angular
  .module('admin.scheduled_messages', ['admin.scheduled_messages.service'])
  .controller('ScheduledMessageAppCtrl', ScheduledMessageAppCtrl)

/** @ngInject */
function ScheduledMessageAppCtrl(ScheduledMessageAppService, UploadService) {
  var vm = this

  vm.items = []
  vm.itemsExpired = []
  vm.itemsPending = []
  vm.perPage = 25
  vm.isOpen = false
  vm.isOpen2 = false

  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }

  vm.openCalendar2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen2 = true
  }

  vm.convertTimezone = function () {
    if (vm.expiresAt) {
      vm.timezoneDatePublishedNY = moment(vm.expiresAt)
        .tz('America/New_York')
        .format('MM/DD/YYYY HH:mm A')
      vm.timezoneDatePublishedLA = moment(vm.expiresAt)
        .tz('America/Los_Angeles')
        .format('MM/DD/YYYY HH:mm A')
    }
    if (vm.pushAt) {
      vm.timezoneDate2PublishedNY = moment(vm.pushAt)
        .tz('America/New_York')
        .format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate2PublishedLA = moment(vm.pushAt)
        .tz('America/Los_Angeles')
        .format('MM/DD/YYYY HH:mm A')
    }
  }

  function reloadPagination() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadPaginationExpired() {
    vm.totalItemsExpired = 0
    vm.oldPageExpired = 0
    vm.currentPageExpired = 25
    vm.firstExpired = true
    vm.totalItemsExpired = 0
    vm.paginationExpired = {
      current: 1,
    }
  }

  function reloadPaginationPending() {
    vm.totalItemsPending = 0
    vm.oldPagePending = 0
    vm.currentPagePending = 25
    vm.firstPending = true
    vm.totalItemsPending = 0
    vm.paginationPending = {
      current: 1,
    }
  }

  reloadPagination()
  reloadPaginationExpired()
  reloadPaginationPending()

  var tab = localStorage.getItem('system_message_tab')
  if (tab !== null) {
    if (tab === 'expired') {
      $('#active').removeClass('active')
      $('#pending').removeClass('active')
      $('#expired').addClass('active')
      $('#expiredtab').addClass('active')
    } else if (tab === 'pending') {
      $('#active').removeClass('active')
      $('#expired').removeClass('active')
      $('#pending').addClass('active')
      $('#pendingtab').addClass('active')
    } else {
      $('#expired').removeClass('active')
      $('#pending').removeClass('active')
      $('#active').addClass('active')
      $('#activetab').addClass('active')
    }
  } else {
    $('#active').addClass('active')
    $('#activetab').addClass('active')
  }

  vm.tabActive = function () {
    $('#expired').removeClass('active')
    $('#pending').removeClass('active')
    $('#active').addClass('active')
    localStorage.setItem('system_message_tab', 'active')
  }

  vm.tabExpired = function () {
    $('#active').removeClass('active')
    $('#pending').removeClass('active')
    $('#expired').addClass('active')
    localStorage.setItem('system_message_tab', 'expired')
  }

  vm.tabPending = function () {
    $('#active').removeClass('active')
    $('#expired').removeClass('active')
    $('#pending').addClass('active')
    localStorage.setItem('system_message_tab', 'pending')
  }

  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    ScheduledMessageAppService.list(vm.oldPage, 25).then(function (result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      vm.items = result.results
    })
  }

  function loadExpired(pageNumber) {
    if (pageNumber === 1) {
      vm.paginationExpired.current = 1
    }
    if (!vm.firstExpired) {
      vm.currentPageExpired = pageNumber * 25
      vm.oldPageExpired = vm.currentPageExpired - 25
    } else {
      vm.firstExpired = false
    }

    ScheduledMessageAppService.listExpired(vm.oldPageExpired, 25).then(function (result) {
      if (vm.totalItemsExpired === 0) {
        vm.totalItemsExpired = result.ct
      }

      vm.itemsExpired = result.results
    })
  }

  function loadPending(pageNumber) {
    if (pageNumber === 1) {
      vm.paginationPending.current = 1
    }
    if (!vm.firstPending) {
      vm.currentPagePending = pageNumber * 25
      vm.oldPagePending = vm.currentPagePending - 25
    } else {
      vm.firstPending = false
    }

    ScheduledMessageAppService.listPending(vm.oldPagePending, 25).then(function (result) {
      if (vm.totalItemsPending === 0) {
        vm.totalItemsPending = result.ct
      }

      vm.itemsPending = result.results
    })
  }

  load(1)
  loadExpired(1)
  loadPending(1)

  vm.load = function () {
    reloadPagination()
    load(1)
  }

  vm.loadExpired = function () {
    reloadPagination()
    loadExpired(1)
  }

  vm.loadPending = function () {
    reloadPaginationPending()
    loadPending(1)
  }

  vm.pageChanged = function (newPage) {
    load(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChangedExpired = function (newPage) {
    loadExpired(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChangedPending = function (newPage) {
    loadPending(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.send = function (item) {
    var message = angular.copy(item)
    var date = new Date()
    date.setSeconds(date.getSeconds() + 1)
    message['ts-pu'] = parseInt(new Date(date).getTime() + '000')
    delete message.cb
    delete message.ts
    delete message['ts-m']
    ScheduledMessageAppService.update(message.id, message).then(
      function () {
        $('#myModalAdd').modal('hide')
        vm.load()
        vm.loadExpired()
        vm.loadPending()
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.add = function () {
    vm.message = {
      id: 0,
      t: '',
      k: 0,
      url: '',
      'img-t': '',
      'ts-pu': null,
      'ts-x': null,
    }
    vm.expiresAt = null
    vm.pushAt = null
    $('#myModalAdd').modal('show')
  }

  vm.edit = function (item) {
    vm.message = angular.copy(item)
    if (vm.message.k === 12) {
      vm.expiresAt = new Date(vm.message['ts-x'] / 1000)
    }
    vm.pushAt = new Date(vm.message['ts-pu'] / 1000)
    vm.convertTimezone()
    delete vm.message.ts
    delete vm.message['ts-m']
    $('#myModalAdd').modal('show')
  }

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.create = function () {
    var message = angular.copy(vm.message)
    if (!message.t) {
      swal('Please enter a Text', '', 'error')
      return
    }
    if (message.k === 12) {
      if (!vm.expiresAt) {
        swal('Please enter a Expires at', '', 'error')
        return
      }
    }
    if (message.k === 11 || message.k === 16) {
      message['id-us'] = parseInt($('#e15').select2('val'))

      if (!vm.pushAt) {
        swal('Please enter a Push at', '', 'error')
        return
      }
      if (!message.m) {
        swal('Please enter a Method', '', 'error')
        return
      }
      if (!message['id-us'] && !message['ids-u']) {
        swal('Please enter a User Segmentation or User IDs', '', 'error')
        return
      }

      if (message.m) {
        message.m = message.m.join()
      }
    }

    if (vm.pushAt) {
      if (isDate(vm.pushAt)) {
        var date = parseInt(new Date(vm.pushAt).getTime() + '000')
        message['ts-pu'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      message['ts-pu'] = null
    }

    if (message.k === 12) {
      if (vm.expiresAt) {
        if (isDate(vm.expiresAt)) {
          var date = parseInt(new Date(vm.expiresAt).getTime() + '000')
          message['ts-x'] = date
        } else {
          swal('Date field invalid.', '', 'error')
          return
        }
      } else {
        message['ts-x'] = null
      }
    }

    ScheduledMessageAppService.save(message).then(
      function () {
        $('#myModalAdd').modal('hide')
        vm.load()
        vm.loadExpired()
        vm.loadPending()
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.update = function () {
    var message = angular.copy(vm.message)
    if (!message.t) {
      swal('Please enter a Text', '', 'error')
      return
    }
    if (message.k === 12) {
      if (!vm.expiresAt) {
        swal('Please enter a Expires at', '', 'error')
        return
      }
    }
    if (message.k === 11 || message.k === 16) {
      message['id-us'] = parseInt($('#e15').select2('val'))

      if (!vm.pushAt) {
        swal('Please enter a Push at', '', 'error')
        return
      }
      if (!message.m) {
        swal('Please enter a Method', '', 'error')
        return
      }
      if (!message['id-us'] && !message['ids-u']) {
        swal('Please enter a User Segmentation or User IDs', '', 'error')
        return
      }

      if (message.m) {
        message.m = message.m.join()
      }
    }

    if (vm.pushAt) {
      if (isDate(vm.pushAt)) {
        var date = parseInt(new Date(vm.pushAt).getTime() + '000')
        message['ts-pu'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      message['ts-pu'] = null
    }

    if (message.k === 12) {
      if (vm.expiresAt) {
        if (isDate(vm.expiresAt)) {
          var date = parseInt(new Date(vm.expiresAt).getTime() + '000')
          message['ts-x'] = date
        } else {
          swal('Date field invalid.', '', 'error')
          return
        }
      } else {
        message['ts-x'] = null
      }
    }

    ScheduledMessageAppService.update(message.id, message).then(
      function () {
        $('#myModalAdd').modal('hide')
        vm.load()
        vm.loadExpired()
        vm.loadPending()
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.delete = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          ScheduledMessageAppService.remove(item.id).then(
            function () {
              $('#myModalAdd').modal('hide')
              vm.load()
              vm.loadExpired()
              vm.loadPending()
            },
            function (err) {
              swal(err.error.message, '', 'error')
            },
          )
        }
      },
    )
  }

  vm.methods = function (val) {
    if (val === '2,4' || val === '4,2') {
      return 'Inbox, Push'
    }
    if (val === '2') {
      return 'Push'
    }
    if (val === '4') {
      return 'Inbox'
    }
  }

  vm.cleanUpUs = function () {
    $('#e15').select2('val', null)
  }

  vm.loadImage = false
  vm.upload = function (item) {
    vm.loadImage = true
    UploadService.save('schedule_messages', vm.pathImg, 'image', item.id).then(function (fileName) {
      vm.loadImage = false
      item['img-t'] = `schedule_messages/${fileName}`
    })
  }
}
